import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import FinancialTable from "../Reusable/InfoTable";
import Filter from "./Filter";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import ACCOUNTS from "../../constant/Accounts";

const columns: ColumnDef<any, any>[] = [
  {
    accessorKey: "tracking_number",
    header: "# Entry No.",
  },
  {
    accessorKey: "delivery_status.name",
    header: "Status",
  },
  {
    accessorKey: "entry_type",
    header: "Entry Type",
  },
  {
    accessorKey: "date",
    header: "Date",
  },
  {
    accessorKey: "ref_no",
    header: "Ref No.",
  },
  {
    accessorKey: "ref_date",
    header: "Ref Date",
  },
];

export default () => {
  const [searchParams] = useSearchParams();

  const getFilters = useCallback(() => {
    const object = Object.fromEntries(searchParams.entries());
    return object;
  }, [searchParams]);
  const { data: profitData, isLoading: isProfitDataloading } = useGetHook({
    queryKey: ["profit"],
    url: APIS.PROFIT_LOSS,
    params: {
      parent: ACCOUNTS.INCOME_ID,
    },
  });
  const { data: lossData, isLoading: isLossDataLoading } = useGetHook({
    queryKey: ["loss"],
    url: APIS.PROFIT_LOSS,
    params: {
      parent: ACCOUNTS.EXPENDITURE_ID,
    },
  });

  return (
    <div className={tw`space-y-2`}>
      <Filter />
      <FinancialTable
        profileData={profitData}
        lossData={lossData}
        isProfitDataloading={isProfitDataloading}
        isLossDataLoading={isLossDataLoading}
      />
    </div>
  );
};
